import axios from '@/utils/axiosHelper'

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/small/snail/beer/init', method: 'POST', params }, { interceptResultCode: false })
}

// 道具列表
export const onListAPI = (params) => {
    return axios({ url: '/small/snail/beer/list', method: 'POST', params }, { interceptResultCode: false })
}

// 新手任务跳转
export const onLinkAPI = (params) => {
    return axios({ url: '/small/snail/beer/jump/time', method: 'POST', params }, { interceptResultCode: false })
}

// 抽奖
export const onDrawAPI = (params) => {
    return axios({ url: '/small/snail/beer/draw', method: 'POST', params }, { interceptResultCode: false })
}

// 道具领取
export const onRewardAPI = (params) => {
    return axios({ url: '/small/snail/beer/reward', method: 'POST', params }, { interceptResultCode: false })
}

// 领取任务奖励
export const onTaskAPI = (params) => {
    return axios({ url: '/small/snail/beer/task', method: 'POST', params }, { interceptResultCode: false })
}

// 角色查询
export const onServerAPI = (params) => {
    return axios({ url: '/login/small', method: 'POST', params }, { interceptResultCode: false })
}

// 角色绑定
export const onBindAPI = (params) => {
    return axios({ url: '/login/small/binds', method: 'POST', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/snail/beer/api.js